import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/MISSOToDispatchReport';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const MISSOToDispatchReport = ({ t }) => (
  <Container>
    <Row>
      <Col md={12} style = {{marginBottom : "-25px"}}>
        <h3 className="page-title">REPORTS - Sales </h3>
      </Col>
    </Row>
       
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

MISSOToDispatchReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MISSOToDispatchReport);
